import React, { useState } from "react";
import FileUpload from "components/UI/FileUpload";
import { axiosCitajteo } from "common/api/axios/citajteo_axios";
import { FILE_UP_NAME } from "constant/file/file_constants";
import { UNIT_FILE_FIELDS_URL } from "./UnitFileFields.const";
import styled from "styled-components";
import UnitsFields from "./UnitsFields";
import { UnitFields } from "type/dl_unit/dl_unit.type";
import UnitExcelUpload from "./UnitExcelUpload";
import {
  UNITS_FIELDS_SOURCE_TYPES,
  UnitsFieldsSourceType,
} from "constant/dl_unit/dl_unit_field.constant";

const UnitFileFields = () => {
  const [fields, setFields] = useState<UnitFields[]>([]);
  const [sourceType, setSourceType] = useState<UnitsFieldsSourceType | "">("");

  const textFileUploadHandle = (data: UnitFields[]) => {
    setSourceType(UNITS_FIELDS_SOURCE_TYPES.TEXT);
    setFields(data);
    console.log("textFileUploadHandle", data);
  };

  const unitExcelDataRetrieveHandle = (fields: UnitFields[]) => {
    console.log("unitExcelDataRetrieveHandle", fields);
    setSourceType(UNITS_FIELDS_SOURCE_TYPES.EXCEL);
    setFields(fields);
  };

  return (
    <Div>
      <div>Unos zapisa preko fajla</div>
      <DivUploads>
        <FileUpload
          axiosInstance={axiosCitajteo}
          fileFieldName={FILE_UP_NAME}
          fileUploadHandle={textFileUploadHandle}
          uploadUrl={UNIT_FILE_FIELDS_URL}
          multiple={false}
          upLabel="tekst"
        />
        <UnitExcelUpload
          onUnitExcelDataRetrieve={unitExcelDataRetrieveHandle}
        />
      </DivUploads>
      <UnitsFields
        sourceType={sourceType}
        fields={fields}
        setFields={setFields}
      />
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const DivUploads = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

export default UnitFileFields;
